import { render, staticRenderFns } from "./HelpCenterDropdown.vue?vue&type=template&id=2327e53e"
import script from "./HelpCenterDropdown.vue?vue&type=script&lang=js"
export * from "./HelpCenterDropdown.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterDropdown.vue?vue&type=style&index=0&id=2327e53e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports